module.exports = __webpack_public_path__ + "static/media/software.43049cae.jpeg";